var map = {
	"./legend_xa.png": "TqRZ",
	"./legend_xa_dark.png": "i0OK",
	"./legend_xa_dark_vertical.png": "oxTJ",
	"./legend_xa_english.png": "K1wN",
	"./legend_xa_english_dark.png": "dxDs",
	"./legend_xa_english_dark_vertical.png": "PoPW",
	"./legend_xa_english_vertical.png": "67TI",
	"./legend_xa_spanish.png": "4mpf",
	"./legend_xa_spanish_dark.png": "+Q/V",
	"./legend_xa_spanish_dark_vertical.png": "UJzI",
	"./legend_xa_spanish_vertical.png": "wdY6",
	"./legend_xa_vertical.png": "4Dgi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JjYJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/legend_xa.*\.png$
// module id = JjYJ
// module chunks = 94